module.exports = __webpack_public_path__ + "img/banner.986dbf2c.png";